module.exports = {"data":{"site":{"siteMetadata":{"title":"Design Resources","description":"A collection of resources for designer and the team.","siteUrl":"https://bl.afnizarnur.com/"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 138
// module chunks = 60335399758886 114276838955818